module.exports = __webpack_public_path__ + "static/img/guide_img_25.fe280651.jpg";